import React, { useState, useEffect, useRef, Suspense } from 'react';
import Table from '../Common/table';
import axios from '../httpServices/httpService';
import api from '../config.json'
import swal from 'sweetalert';
import auth from '../httpServices/authService';
import validation from '../utill/validation';
import _, { cloneDeep, result } from 'lodash';
import joi, { object } from 'joi'
import Loading from '../utill/LoadingComponent';
import date from '../utill/dateTime';
// import EquipmentSelection from '../Common/equipmentSelection';
import { ToastContainer, toast } from 'react-toastify';
import DateSelection from '../Common/DateSelection';
import { Button, Modal, Select } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faFilePdf, faMinusCircle, faPlusCircle, faThumbsDown, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/vg.png';
import ExportPdfButton from '../utill/ExportPdf';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
// import ProcessProductPatrolInspection from '../MARELLITALBROS/ProcessProductPatrolInspection';
// import PokaYokeSheet from '../MARELLITALBROS/PokayokeMonitoringSheet';
// import DailyInitialFlowManagement from '../MARELLITALBROS/DailyInitialFlowManagement';
import DataEntryReportView from '../pdfFormat/DataEntryReportView';
import Tooltip from '../utill/tooltip';
// import DailyInitialFlowManagement_PROCESS from '../MARELLITALBROS/DailyIMFFaridabad_Process_Parameter';
import PaginationComponent from '../Common/PaginationComponent';
// import InprocessInspectionReport from '../PPPF02/Inprocess-InspectionReport';
// import SetUp_Fisrt_Last_Approval_Report from '../PPPF02/SetUp_First_Last_Approval_Report';






const QMSReport = ({ handleDownloadTableToExcel, equips, equipGroups, fromDateLimit, Heading, companyName }) => {
    const RemoveSpace = (str) => {
        const result = str.replace(/\s+/g, "").toUpperCase();
        return result;
    }
    if (companyName) {

        console.log("Company Name", RemoveSpace(companyName))
    }
    const SetUp_Fisrt_Last_Approval_Report = React.lazy(() => import(`../${RemoveSpace(companyName)}/SetUp_First_Last_Approval_Report`));
    const DailyInitialFlowManagement_PROCESS = React.lazy(() => import(`../${RemoveSpace(companyName)}/DailyIMFFaridabad_Process_Parameter`));
    // const DataEntryReportView = React.lazy(() => import(`../${RemoveSpace(companyName)}/DataEntryReportView`));
    const DailyInitialFlowManagement = React.lazy(() => import(`../${RemoveSpace(companyName)}/DailyInitialFlowManagement`));
    const PokaYokeSheet = React.lazy(() => import(`../${RemoveSpace(companyName)}/PokayokeMonitoringSheet`));
    const ProcessProductPatrolInspection = React.lazy(() => import(`../${RemoveSpace(companyName)}/ProcessProductPatrolInspection`));
    const InprocessInspectionReport = React.lazy(() => import(`../${RemoveSpace(companyName)}/Inprocess-InspectionReport`));



    const reportType = [
        // { label: "Incoming Inspection", value: "Incoming", name: "IncomingInspection" },
        // { label: "First Part Inspection", value: "FirstPart", name: "FirstPartInspection" },
        // { label: "Inprocess Inspection", value: "Inprocess", name: "InProcessInspection" },
        // { label: "Last Part Inspection ", value: "LastPart", name: "LastPartInspection" },
        // { label: "FinishedGoods Inspection", value: "FinishedGoods", name: 'FG_Inspection' }
    ]
    const [qualityData, setQualityData] = useState([])
    const [inputData, setInputData] = useState({ From: new Date(), Till: new Date() });
    const [parts, setAllParts] = useState([]);
    const [types, setAllTypes] = useState([]);
    const [allTypeCache, setAllTypeCache] = useState([]);
    const [querySuccess, setQuerySuccess] = useState(false);
    const [sortColumn, setSortColumn] = useState({ path: 'PartID', order: 'asc' })
    const [open, setOpen] = useState(false);
    const [pdfOpen, setPdfOpen] = useState(false);
    const [reportData, setReportData] = useState([]);
    const [selectedItem, setSelectedItem] = useState({});
    const [checkPointTemplates, setCheckPointTemplates] = useState([]);
    const [company, setCompany] = useState({})
    const [loader, setLoader] = useState(false)
    const [methods, setMethods] = useState([])
    const [arrayLenght, setArrayLenght] = useState(0);
    const [allPartsCache, setAllPartsCache] = useState([]);
    const [itemNumber, setAllItemNumber] = useState([]);
    const [operations, setAllOperations] = useState([]);
    const [selectedTemplates, setSelectedTemplate] = useState({ Columns: [] })
    const [pdfData, setPdfData] = useState([])
    const [CurrentPage, setCurrentPage] = useState(1);
    const [TotalPage, setTotalPage] = useState(5);
    const [PageSize, setPageSize] = useState(25);

    const customerRef = useRef(null);
    // const filteredOptions = clients.filter((o) => !selectedItems.find(b => o.label == b));

    useEffect(() => {
        Heading('View Report')
        GetAllInspetcionTypes();
        getAllPart();
        getAllMethods();
        getCompanyDetail()
        getAllTemplate()

        handleGetData("Default")
    }, [])

    const getCompanyDetail = () => {
        axios.get(api.api + 'company/' + auth.getCurrentUser().company)
            .then((result) => {
                setCompany(result.data)
            })
            .catch((err) => {
                console.error(err);
            });
    }

    const demoFromHTML = async () => {
        const source = customerRef.current;

        // Wait for all images in the source element to be loaded
        const loadImages = () => {
            const images = source.getElementsByTagName('img');
            const promises = Array.from(images).map((img) => {
                return new Promise((resolve) => {
                    if (img.complete) {
                        resolve();
                    } else {
                        img.onload = resolve;
                        img.onerror = resolve; // Resolve in case of an error as well
                    }
                });
            });
            return Promise.all(promises);
        };

        // Wait for images to load
        await loadImages();

        const table = source.querySelector('table'); // Target the table element
        const rows = Array.from(table.querySelectorAll('tr')); // Get all rows of the table

        const maxRowsPerPage = 25; // Set 25 rows per page
        const totalRows = rows.length;
        const numPages = Math.ceil(totalRows / maxRowsPerPage); // Calculate the number of pages needed

        const pdf = new jsPDF('landscape', 'pt', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const margin = 20;
        const marginWidth = margin;
        const marginHeight = margin;

        const availableWidth = pdfWidth - 2 * marginWidth;
        const availableHeight = pdfHeight - 2 * marginHeight;

        for (let page = 0; page < numPages; page++) {
            const canvas = await html2canvas(source, { scale: 2 });

            // Get only the rows for the current page (25 rows per page)
            const startRow = page * maxRowsPerPage;
            const endRow = Math.min((page + 1) * maxRowsPerPage, totalRows);
            const currentRows = rows.slice(startRow, endRow);

            // Temporarily hide rows not belonging to the current page
            rows.forEach((row, index) => {
                row.style.display = index >= startRow && index < endRow ? '' : 'none';
            });

            // Re-render the canvas for the current page's content
            const canvasForPage = await html2canvas(source, { scale: 2 });
            const imgData = canvasForPage.toDataURL('image/jpeg', 0.7);

            const imgHeight = (canvasForPage.height * availableWidth) / canvasForPage.width;
            const position = marginHeight;

            // Add content to the PDF for the current page
            pdf.addImage(
                imgData,
                'JPEG',
                marginWidth,
                position,
                availableWidth,
                imgHeight > availableHeight ? availableHeight : imgHeight
            );

            if (page < numPages - 1) {
                pdf.addPage(); // Add a new page if it's not the last one
            }
        }

        // Restore all rows to be visible after generating the PDF
        rows.forEach(row => (row.style.display = ''));

        pdf.save(`${reportData.InspectionType}_${new Date(reportData.DateTime).toLocaleString()}.pdf`);
    };







    const demoFromHTML1 = async () => {
        const source = customerRef.current;
        const canvas = await html2canvas(source);
        const imgData = canvas.toDataURL('image/png');

        const pdf = new jsPDF('p', 'pt', 'letter', true);
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const margin = 0.02; // 2% margin
        const marginWidth = pdfWidth * margin;
        const marginHeight = pdfHeight * margin;

        const availableWidth = pdfWidth - 2 * marginWidth;
        const availableHeight = (imgProps.height * availableWidth) / imgProps.width;

        pdf.addImage(
            imgData,
            'PNG',
            marginWidth,
            marginHeight,
            availableWidth,
            availableHeight > pdfHeight - 2 * marginHeight ? pdfHeight - 2 * marginHeight : availableHeight
        );

        pdf.save('Test.pdf');
    };



    const handleOnChange = (name, value) => {
        const obj = { ...inputData }
        obj[name] = value;
        setInputData(obj);
        console.log(obj);
        if (name == "InspectionType") {

            if (
                obj.ItemName?.length > 0 ||
                obj.Operation?.length > 0 ||
                obj.ItemNumber?.length > 0
            ) {
                obj.ItemName = [];
                obj.ItemNumber = [];
                obj.Operation = [];
                setInputData({ ...obj });
                setAllOperations([])
                setAllItemNumber([])
                setAllParts([])

            }

            const numbers = allPartsCache
                .filter(one => one.Inspection.some(x => (value.includes(x.InspectionName)) && x.Enable) || value.includes("All"))
                .map(one => ({ label: one.ItemName, value: one.ItemName }));

            setAllParts(numbers);

        }
        if (name == "ItemName") {
            if (obj.ItemNumber?.length > 0) {
                obj.ItemNumber = [];
                obj.Operation = [];
                console.log(obj, "Clearing ItemNumber and Operation for ItemName");
                setInputData({ ...obj });
            }

            const numbers = allPartsCache.map((one) => {
                if (value.includes(one.ItemName) || value.includes("All")) {
                    return { label: one.ItemNumber, value: one.ItemNumber }
                }
            })
            setAllItemNumber(numbers.filter(x => x))

        }
        if (name == "ItemNumber") {
            if (obj.Operation?.length > 0) {
                obj.Operation = [];
                console.log(obj, "Clearing Operation for ItemNumber");
                setInputData({ ...obj });
            }
            const operations = allPartsCache.map((one) => {
                if ((inputData.ItemName && inputData.ItemName.includes(one.ItemName) || inputData.ItemName.includes("All")) && (value.includes(one.ItemNumber) || value.includes("All"))) {
                    return { label: one.Operation, value: one.Operation }
                }
            })
            setAllOperations(operations.filter(x => x));
        }
    }



    const getAllMethods = () => {
        axios.get(api.api + "method")
            .then((result) => {
                setMethods(result.data)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }


    const getAllInspection = () => {
        axios.get(api.api + "inspectionType")
            .then((result) => {
                const all = result.data.map((one) => { return { label: one.InspectionType, value: one.InspectionType } })
                setAllTypes(all)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }

    const getAllPart = () => {
        axios.get(api.api + "item")
            .then((result) => {
                setAllPartsCache(result.data)

                const all = result.data.map((one) => { return { label: one.ItemName, value: one.ItemName } })

                // setAllParts(all)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }


    useEffect(() => {
        validateAndApply()

    }, [CurrentPage, PageSize]);

    const validateAndApply = () => {
        if (!inputData.InspectionType || (inputData.InspectionType.length == 0)) {
            return
        }
        if (!inputData.ItemName || (inputData.ItemName.length == 0)) {
            return
        }
        if (!inputData.ItemNumber || (inputData.ItemNumber.length == 0)) {
            return
        }
        if (!inputData.Operation || (inputData.Operation.length == 0)) {
            return
        }
        handleGetData("Param")
    }

    const handleGetData = async (type) => {
        // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
        setLoader(true)
        axios.put(api.api + 'GetReport', { query: inputData, PageSize: PageSize, Page: CurrentPage, RequestType: type })
            .then((result) => {
                setLoader(false)

                if (type == "Default") {
                    const obj = { ...inputData, InspectionType: ["All"], ItemName: ["All"], ItemNumber: ["All"], Operation: ["All"] };
                    setInputData(obj);
                }
                setTotalPage(Math.ceil(result.data.totalDocument / PageSize));
                setQualityData(result.data.data);
                //setArrayLenght(result.data.length > 0 ? result.data[0].Reports.length : 0)
            })

            .catch((err) => {
                setLoader(false)
                console.log(err);
            })
    }

    async function getBase64FromImageUrl(url) {
        try {
            // Fetch the image data from the URL
            const response = await fetch(url);
            const blob = await response.blob();

            // Create a FileReader to convert the Blob to base64
            const reader = new FileReader();

            return new Promise((resolve, reject) => {
                reader.onloadend = function () {
                    // Extract base64 string from the data URL
                    const base64String = reader.result.split(',')[1];
                    resolve(base64String);
                };

                reader.onerror = function (error) {
                    reject(error);
                };

                // Read the Blob as a data URL
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error('Error fetching or converting image:', error);
            throw error;
        }
    }



    const handleGetPdfData = async (query) => {
        // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
        setLoader(true)
        axios.put(api.api + 'ViewReport', query)
            .then((result) => {
                setPdfData(result.data);
                setLoader(false)
            })
            .catch((err) => {
                setLoader(false)
                console.log(err);
            }).finally(() => {
                setLoader(false)
            })
    }
    const handleGetPdfData1 = async (query, ReportList) => {
        // const ReportList = ["Inprocess Inspection - CTQ", "Inprocess Inspection - Appearance"];

        // const ReportList = ["First Part Inspection","Last Part Inspection"];
        console.log("PDF Data fvdfv", query, ReportList)

        setLoader(true);

        try {
            const responses = await Promise.all(
                ReportList.map(async (one) => {
                    const result = await axios.put(api.api + 'ViewReport', { ...query, InspectionType: one });
                    return { InspectionType: one, data: result.data }; // Store InspectionType with data
                })
            );
            console.log(responses, "vdfkjndfj");

            setPdfData(responses); // Now an array of objects
        } catch (err) {
            console.error(err);
        } finally {
            setLoader(false);
        }
    };





    const handleInputChange = (parentIdx, index, e) => {
        const data = { ...qualityData };
        data[parentIdx].Standard[index][e.currentTarget.name] = e.currentTarget.value;

        setQualityData(qualityData)
    }

    const handleOnSubmit = () => {
        const data = [...qualityData];
        const obj = { PartID: inputData.PartID, InspectionType: inputData.InspectionType, DateTime: inputData.DateTime, Reports: [] }
        data.forEach((sample, index) => {
            const reports = { SampleSerial: index + 1, InspectionData: [] }
            sample.Standard.forEach((one, index) => {
                reports.InspectionData.push({ Parameter: one.Parameter, ObservedValue: one.ObservedValue, Result: one.Result, Remarks: one.Remarks, StandardType: one.StandardType })
            })
            obj.Reports.push(reports);
        })
        axios.post(api.api + "inspectionReport", obj)
            .then((result) => {
                setQualityData([])
                swal("Data Saved Successfully")
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const addMore = () => {
        const data = cloneDeep(qualityData);
        const obj = cloneDeep(data[data.length - 1])
        obj.Standard.forEach((one) => {
            delete one.ObservedValue
            delete one.Result
            delete one.Remarks
        })
        setQualityData([...data, obj]);
    }

    const removeRow = () => {
        let data = [...qualityData];
        data.splice(data.length - 1, 1)
        setQualityData(data);
    }



    const getStandardType = (obj) => {
        if (obj && obj.StandardType == "Dimension") {
            return `(Dimension (+${obj.PlusTolerance}/-${obj.MinusTolerance}))`
        }
        return `(Description)`
    }

    const extractInspectionDataSeparateArray = (data) => {

        const separateInspectionDataArray = [];

        // Iterate through each report
        if (data) {
            console.log(data, "testingthe data")
            data && data.Reports && data.Reports.forEach((report) => {
                // Iterate through InspectionData in the report
                report.InspectionData.forEach((inspection) => {
                    const parameter = inspection.Parameter;
                    const existingEntry = separateInspectionDataArray.find(entry => entry.Parameter === parameter);

                    if (existingEntry) {
                        existingEntry.InspectionData.push(inspection);
                    } else {
                        separateInspectionDataArray.push({
                            Parameter: parameter,
                            InspectionData: [inspection]
                        });
                    }
                });
            });
        }

        data.InspectionData = separateInspectionDataArray
        console.log(data, "data for the table")
        return [data];
    };

    const getRange = (one) => {
        let str = '-'
        if (one.StandardType == "Dimension") {
            const dim = parseFloat(one.Dimension)
            const plus = dim + parseFloat(one.PlusTolerance)
            const minus = dim - parseFloat(one.MinusTolerance)
            str = `( ${plus} - ${minus} ) ${one.UOM}`
        }

        return str
    }

    const getItem = () => {
        const item = allPartsCache.find(part => part.ItemName == reportData.Item && part.ItemNumber == reportData.ItemNumber && part.Operation == reportData.Operation);
        if (item) {
            return item
        }
        return {}
    }


    const reportTypes = [
        "Retrospective Inspection",
        "Setup Approval Inspection",
        "Process/Product Patrol Inspection",
        "Poka - Yoke Sheet",
        "IFM - Product - Msr",
        "IFM - Process - Fbd",
        "IFM_Product_FBD",
        "Last Part Inspection",
        "First Part Inspection",
        "Inprocess Inspection - CTQ",
        "Inprocess Inspection - Appearance",
        "Inprocess Inspection - CTP",
        "POKA YOKE FOR SPM MACHIN",
        "POKA YOKE FOR IMM MACHIN"


    ]

    const getGroupByField = (obj) => {
        if (obj && obj.InspectionType) {
            const inspectionType = allTypeCache.find(x => x.InspectionType == obj.InspectionType)
            if (inspectionType) {
                let fields = inspectionType.CustomFields.filter(x => x.UsedForGroupBy)
                if (fields.length > 0) {
                    fields = fields.map(x => x.FieldName)
                    return fields.map(x => {
                        const field = obj.customFields.find(y => y.FieldName == x)
                        if (field && field.FieldName == "Date_Shift") {
                            field.Value = moment(field.Value).format('DD-MM-YYYY')
                            return field
                        }
                        return field
                    }).map(x => x && x.Value).filter(x => x).join(" | ")
                }
            }
        }
        return '-'
    }
    const columns1 = [
        { path: "SerialNumber", label: "Serial Number" },
        { path: "DateTime", label: "Date", content: (obj) => (<>{moment(obj.DateTime).format('DD-MM-YY')}</>) },
        { path: "DateTime", label: "Time", content: (obj) => (<>{moment(obj.DateTime).format('hh:mm a')}</>) },
        { path: "Item", label: "Item Name" },
        { path: "ItemNumber", label: "Item Number" },
        { path: "Operation", label: "Operation" },
        { path: "InspectionType", label: "Inspection Type" },
        {
            path: "key", label: "Report For", content: (obj) => <>{getGroupByField(obj)}</>
        },
        { path: "QtyToInspect", label: "Qty To Inspect" },
        { path: "QtyInspected", label: "Qty Inspected" },
        { path: "OkParts", label: "Ok Parts" },
        { key: "Reject Parts", label: "Reject Parts", content: (obj) => (<>{obj.QtyToInspect - obj.OkParts}</>) },
        { path: "State", label: "Status" },
        {
            key: "InspectionData",
            label: <table class="table table-bordered mb-0 m-0 p-0">
                <thead>
                    <tr>
                        {[...Array(arrayLenght)].map((item, index) => (<>
                            <th colSpan={3}>{'Sample ' + (index + 1)}</th>
                        </>))}
                    </tr>
                </thead>
            </table>,
            content: (obj) => (
                <React.Fragment>
                    <table class="table table-bordered">
                        <thead>
                            {/* <tr>
                {[...Array(obj.InspectionData[0].InspectionData.length)].map((item,index) => (<>
                  <th  colSpan={3}>{'Sample '+(index+1) }</th>
                  </> ))}
                   </tr> */}
                            <tr>
                                {/* { obj.InspectionData.length > 0 && [...Array(obj.InspectionData[0].InspectionData.length)].map((item,index) => (<>
                 <th  >Observation</th ><th  >Result</th ><th  >Remarks</th >
                  </> ))} */}
                            </tr>
                        </thead>
                        {/* <tbody >
                {obj.InspectionData.map((item,index) => (<tr>
                  {item.InspectionData.map((one,idx)=><> <td>{one.ObservedValue}</td><td style={{backgroundColor:`${one.Result==='NA' ?'#FFA500':(one.Result==='NG') ?'red':'#28A745'}`}}>{one.Result}</td><td>{one.Remarks}</td></>)}
                  </tr> ))}
              </tbody> */}
                    </table>
                </React.Fragment>
            ),
        },
        {
            key: "view",
            label: "View Report",
            content: (obj) => (
                <React.Fragment>
                    <button className='btn btn-secondary' onClick={() => {
                        const part = allPartsCache.find((part) => part.ItemName == obj.Item && part.ItemNumber == obj.ItemNumber && part.Operation == obj.Operation)
                        if (part) {
                            handleGetPdfData({ _id: obj._id, InspectionType: obj.InspectionType, ItemName: obj.Item, ItemNumber: obj.ItemNumber, Operation: obj.Operation, From: obj.DateTime, Till: obj.DateTime })
                            const checkSheet = part.Inspection.find(x => x.InspectionName == obj.InspectionType)
                            const template = checkPointTemplates.find(x => checkSheet.checkSheetTitle.length > 0 && checkSheet.checkSheetTitle.some(c => c.TemplateName == x.Name))
                            //template.Columns = template.Columns.filter(x => x.EnableForDataEntry)
                            setSelectedTemplate(template)
                        }
                        setReportData(obj);
                        setOpen(true)

                    }}>
                        <FontAwesomeIcon icon={faFile} />
                    </button>
                </React.Fragment>
            ),
        },
        {
            key: "PDF View",
            label: "View PDF",
            content: (obj) => (
                <React.Fragment>
                    {
                        reportTypes.filter(item => item == obj.InspectionType).length > 0 ? <button className='btn btn-secondary' onClick={() => {
                            const part = allPartsCache.find((part) => part.ItemName == obj.Item && part.ItemNumber == obj.ItemNumber && part.Operation == obj.Operation)
                            if (part) {
                                const checkSheet = part.Inspection.find(x => x.InspectionName == obj.InspectionType)
                                const template = checkPointTemplates.find(x => checkSheet.checkSheetTitle && (checkSheet.checkSheetTitle.includes(z => z.TemplateName == x.Name)))
                                // template.Columns = template.Columns.filter(x => x.EnableForDataEntry)
                                setSelectedTemplate(template)
                                const shift = obj.customFields.find(x => x && x.FieldName == "Shift")
                                const batchCode = obj.customFields.find(x => x && x.FieldName == "Batch Code")
                                const machine = obj.customFields.find(x => x && x.FieldName == "Machine")
                                if (obj.InspectionType == "Poka - Yoke Sheet"||obj.InspectionType == "POKA YOKE FOR IMM MACHIN"||obj.InspectionType == "POKA YOKE FOR SPM MACHIN") {
                                    const reportDate = moment(obj.DateTime);

                                    // Start of the month
                                    const startOfMonth = reportDate
                                        .startOf("month")
                                        .format("YYYY-MM-DD");

                                    // End of the month
                                    const endOfMonth = reportDate
                                        .endOf("month")
                                        .format("YYYY-MM-DD");
                                    // Output: 2024-12-31

                                    handleGetPdfData({
                                        _id: obj._id,
                                        InspectionType: obj.InspectionType,
                                        ItemName: obj.Item,
                                        ItemNumber: obj.ItemNumber,
                                        Operation: obj.Operation,
                                        From: startOfMonth,
                                        Till: endOfMonth,
                                        Shift: shift ? shift.Value : "",
                                    });
                                } else if (obj.InspectionType === "Inprocess Inspection - CTQ" || obj.InspectionType === "Inprocess Inspection - Appearance" || obj.InspectionType === "Inprocess Inspection - CTP") {

                                    handleGetPdfData1({ _id: obj._id, InspectionType: obj.InspectionType, ItemName: obj.Item, ItemNumber: obj.ItemNumber, Operation: obj.Operation, From: obj.DateTime, Till: obj.DateTime, Shift: shift ? shift.Value : "" }, ["Inprocess Inspection - CTQ", "Inprocess Inspection - Appearance", "Inprocess Inspection - CTP"])
                                } else if (obj.InspectionType === "First Part Inspection" || obj.InspectionType === "Last Part Inspection") {

                                    handleGetPdfData1({ _id: obj._id, InspectionType: obj.InspectionType, ItemName: obj.Item, ItemNumber: obj.ItemNumber, Operation: obj.Operation, From: obj.DateTime, Till: obj.DateTime, Shift: shift ? shift.Value : "" }, ["First Part Inspection", "Last Part Inspection"])
                                }
                                else {
                                    handleGetPdfData({ _id: obj._id, InspectionType: obj.InspectionType, ItemName: obj.Item, ItemNumber: obj.ItemNumber, Operation: obj.Operation, From: obj.DateTime, Till: obj.DateTime, Machine: machine, BatchCode: batchCode, Shift: shift ? shift.Value : "" })
                                }
                            }
                            setSelectedItem(part)
                            setReportData(obj);
                            setPdfOpen(true)
                        }}>
                            <FontAwesomeIcon icon={faFilePdf} />
                        </button>
                            : <Tooltip text="Report Unavailable">
                                <button className='btn btn-secondary' disabled={true}>
                                    <FontAwesomeIcon icon={faFilePdf} />

                                </button>
                            </Tooltip>}


                </React.Fragment>
            ),
        },
        // {
        //     key: "Reffer",
        //     label: "",
        //     content: (obj) => {
        //         return <React.Fragment>
        //            {obj.State=="Closed" && <Button key="submit" type="primary" onClick={() => handleRfferBack('Preparing',obj)}>
        //                 Reffer Back
        //             </Button>}
        //         </React.Fragment>
        //     }
        // }
    ];

    const handleRfferBack = (state, obj) => {
        const message = (state == "Closed" ? "You Have Approved The Inspection " : "You Have Reffer Back The Inspection ")
        swal({
            title: 'Are you sure you want to refer back for editing the inspection report?',
            // text: `${err.response.data.message}`,
            icon: "warning",
            buttons: true,
            dangerMode: true
        }).then(WillApprove => {
            if (WillApprove) {
                axios.put(api.api + "checkSheetDataEntry", { id: obj._id, State: state })
                    .then((result) => {
                        if (result.status == 200) {
                            handleGetData("Param")
                            setOpen(false)
                            toast.success(message, {
                                position: 'top-right',
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                style: {
                                    backgroundColor: 'green',
                                    color: 'white',
                                },
                            });
                        }


                    })
                    .catch((err) => {
                        if (err.response && err.response.data) {
                            swal(err.response.data.message, { dangerMode: true })
                        } else {
                            swal(`${err}`, { dangerMode: true })
                        }
                    })
            }
            else {
                // Handle Cancel button click
                toast.success(`You Have Rejected Reffer Back The Inspection `, {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    style: {
                        backgroundColor: 'red',
                        color: 'white',
                    },
                });
                console.log('Cancelled');
            }
        });


    }

    const GetAllInspetcionTypes = () => {
        axios.get(api.api + 'customInspection')
            .then((result) => {
                const reports = [...reportType]
                result.data.forEach((one) => {
                    const obj = { label: one.InspectionType, value: one.InspectionType, name: one.InspectionType }
                    reports.push(obj)
                })
                setAllTypeCache(result.data)
                setAllTypes(reports)
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const getAllTemplate = () => {
        axios.get(api.api + "checkPointConfig")
            .then((result) => {
                setCheckPointTemplates(result.data)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }

    const reports = {
        "Retrospective Inspection": (
            <Suspense fallback={<div>Loading...</div>}>
                <ProcessProductPatrolInspection
                    item={
                        allPartsCache?.find((x) => x.ItemName === inputData?.ItemName) || {}
                    }
                    company={company}
                    data={reportData}
                    pdfData={pdfData}
                    test={qualityData}
                />
            </Suspense>
        ),

        "Setup Approval Inspection": (
            <Suspense fallback={<div>Loading...</div>}>

                <ProcessProductPatrolInspection
                    item={
                        allPartsCache?.find((x) => x.ItemName === inputData?.ItemName) || {}
                    }
                    company={company}
                    data={reportData}
                    pdfData={pdfData}
                />
            </Suspense>

        ),

        "Process/Product Patrol Inspection": (
            <Suspense fallback={<div>Loading...</div>}>
                <ProcessProductPatrolInspection
                    item={
                        allPartsCache?.find((x) => x.ItemName === inputData?.ItemName) || {}
                    }
                    company={company}
                    data={reportData}
                    pdfData={pdfData}
                />
            </Suspense>
        ),

        //   "Last Part Inspection": (
        //     <Suspense fallback={<div>Loading...</div>}>
        //       <InprocessInspectionReport
        //         item={
        //           allPartsCache?.find((x) => x.ItemName === inputData?.ItemName) ||
        //           {}
        //         }
        //         company={company}
        //         data={reportData}
        //         pdfData={pdfData}
        //       />
        //     </Suspense>
        //   ),

        "Inprocess Inspection - Appearance": (
            <Suspense fallback={<div>Loading...</div>}>
                <InprocessInspectionReport
                selectedItem={selectedItem}
                    item={
                        allPartsCache?.find((x) => x.ItemName === inputData?.ItemName) || {}
                    }
                    company={company}
                    data={reportData}
                    pdfData={
                        Array.isArray(pdfData)
                            ? pdfData.find(
                                (one) => one.InspectionType === "Inprocess Inspection - CTQ"
                            )?.data || []
                            : []
                    }
                    pdfData1={
                        Array.isArray(pdfData)
                            ? pdfData.find(
                                (one) => one.InspectionType === "Inprocess Inspection - Appearance"
                            )?.data || []
                            : []
                    }
                    pdfData2={
                        Array.isArray(pdfData)
                            ? pdfData.find(
                                (one) => one.InspectionType === "Inprocess Inspection - CTP"
                            )?.data || []
                            : []
                    }
                />
            </Suspense>

        ),
        "Inprocess Inspection - CTQ": (
            <Suspense fallback={<div>Loading...</div>}>
                <InprocessInspectionReport
                selectedItem={selectedItem}
                    item={
                        allPartsCache?.find((x) => x.ItemName === inputData?.ItemName) || {}
                    }
                    company={company}
                    data={reportData}
                    pdfData={
                        Array.isArray(pdfData)
                            ? pdfData.find(
                                (one) => one.InspectionType === "Inprocess Inspection - CTQ"
                            )?.data || []
                            : []
                    }
                    pdfData1={
                        Array.isArray(pdfData)
                            ? pdfData.find(
                                (one) => one.InspectionType === "Inprocess Inspection - Appearance"
                            )?.data || []
                            : []
                    }
                    pdfData2={
                        Array.isArray(pdfData)
                            ? pdfData.find(
                                (one) => one.InspectionType === "Inprocess Inspection - CTP"
                            )?.data || []
                            : []
                    }
                />
            </Suspense>

        ),
        "Inprocess Inspection - CTP": (
            <Suspense fallback={<div>Loading...</div>}>
                <InprocessInspectionReport
                selectedItem={selectedItem}
                    item={
                        allPartsCache?.find((x) => x.ItemName === inputData?.ItemName) || {}
                    }
                    company={company}
                    data={reportData}
                    pdfData={
                        Array.isArray(pdfData)
                            ? pdfData.find(
                                (one) => one.InspectionType === "Inprocess Inspection - CTQ"
                            )?.data || []
                            : []
                    }
                    pdfData1={
                        Array.isArray(pdfData)
                            ? pdfData.find(
                                (one) => one.InspectionType === "Inprocess Inspection - Appearance"
                            )?.data || []
                            : []
                    }
                    pdfData2={
                        Array.isArray(pdfData)
                            ? pdfData.find(
                                (one) => one.InspectionType === "Inprocess Inspection - CTP"
                            )?.data || []
                            : []
                    }
                />
            </Suspense>

        ),

        "Last Part Inspection": (<Suspense fallback={<div>Loading...</div>}>
            {console.log(reportData, "pdfData in last part inspection")}

            <SetUp_Fisrt_Last_Approval_Report
                item={
                    allPartsCache?.find((x) => x.ItemName === inputData?.ItemName) || {}
                }
                company={company}
                data={
                    reportData
                }
                MarelliPDFData={pdfData}
                pdfData=
                {
                    Array.isArray(pdfData)
                        ? pdfData.find(
                            (one) => one.InspectionType === "First Part Inspection"
                        )?.data || []
                        : []
                }
                pdfData1={
                    Array.isArray(pdfData)
                        ? pdfData.find(
                            (one) => one.InspectionType === "Last Part Inspection"
                        )?.data || []
                        : []
                }

            />
        </Suspense>
        ),
        "First Part Inspection": (
            <Suspense fallback={<div>Loading...</div>}>

                <SetUp_Fisrt_Last_Approval_Report
                    item={
                        allPartsCache?.find((x) => x.ItemName === inputData?.ItemName) || {}
                    }
                    company={company}
                    data={reportData}
                    pdfData=
                    {
                        Array.isArray(pdfData)
                            ? pdfData.find(
                                (one) => one.InspectionType === "First Part Inspection"
                            )?.data || []
                            : []
                    }
                    pdfData1={
                        Array.isArray(pdfData)
                            ? pdfData.find(
                                (one) => one.InspectionType === "Last Part Inspection"
                            )?.data || []
                            : []
                    }

                />
            </Suspense>
        ),
        "Poka - Yoke Sheet": (<Suspense fallback={<div>Loading...</div>}>

            <PokaYokeSheet company={company} obj={reportData} data={pdfData} />
        </Suspense>
        ),

        "POKA YOKE FOR SPM MACHIN": (<Suspense fallback={<div>Loading...</div>}>

            <PokaYokeSheet company={company} obj={reportData} data={pdfData} />
        </Suspense>
        ),

        "POKA YOKE FOR IMM MACHIN": (<Suspense fallback={<div>Loading...</div>}>

            <PokaYokeSheet company={company} obj={reportData} data={pdfData} />
        </Suspense>
        ),

        "IFM - Product - Msr": (<Suspense fallback={<div>Loading...</div>}>

            <DailyInitialFlowManagement
                company={company}
                data={reportData}
                pdfData={pdfData}
                test={qualityData}
            />
        </Suspense>
        ),

        "IFM - Process - Fbd": (<Suspense fallback={<div>Loading...</div>}>

            <DailyInitialFlowManagement_PROCESS
                company={company}
                data={reportData}
                test={qualityData}
            />
        </Suspense>
        ),

        "IFM_Product_FBD": (<Suspense fallback={<div>Loading...</div>}>

            <DailyInitialFlowManagement
                company={company}
                data={reportData}
                pdfData={pdfData}
                test={qualityData}
            />
        </Suspense>
        ),
    };


    return (
        <React.Fragment>
            {loader ? <Loading labelShow={true} label={"Loading..."} /> : ''}
            {/* <div className='text-center' >
                <p >QMS Report</p>
            </div> */}

            {/* <ToastContainer /> */}

            <div className="row">
                <div className="col-sm-2">
                    <div className="form-group">
                        <label className='small'>From</label>
                        <input value={moment(inputData.From).format('YYYY-MM-DD')} className='form-control form-control-sm' onChange={(e) => handleOnChange('From', e.currentTarget.value)} type='date' />

                    </div>
                </div>
                <div className="col-sm-2">
                    <div className="form-group">
                        <label className='small'>Till</label>
                        <input value={moment(inputData.Till).format('YYYY-MM-DD')} className='form-control form-control-sm' onChange={(e) => handleOnChange('Till', e.currentTarget.value)} type='date' />

                    </div>
                </div>
                <div className='col-sm-2'>
                    <label className='small text-center'>Inspection Type</label>
                    <Select
                        showSearch
                        maxTagCount={"responsive"}
                        mode="multiple"
                        placeholder="Select Inspection Type"
                        value={inputData.InspectionType}
                        onChange={(values) => {
                            if (values.includes('All')) {
                                if (inputData.InspectionType && (inputData.InspectionType.length === types.length)) {
                                    handleOnChange('InspectionType', []);
                                } else {
                                    handleOnChange('InspectionType', ["All"]);
                                }
                            } else {
                                // Update selected values normally
                                handleOnChange('InspectionType', values);
                            }
                        }}
                        style={{ width: '100%' }}
                        options={[
                            { label: 'All', value: 'All' },
                            ...types
                        ]}
                    />

                </div>
                <div className='col-sm-2'>
                    <label className='small text-center'>Item</label>
                    <Select
                        showSearch
                        maxTagCount={"responsive"}
                        mode="multiple"
                        placeholder="Select Item"
                        value={inputData.ItemName}
                        onChange={(values) => {
                            if (values.includes('All')) {
                                if (inputData.ItemName && (inputData.ItemName.length === parts.length)) {
                                    // Deselect all if "Select All" was deselected
                                    handleOnChange('ItemName', []);
                                } else {
                                    // Select all
                                    handleOnChange('ItemName', ["All"]);
                                }
                            } else {
                                // Update selected values normally
                                handleOnChange('ItemName', values);
                            }
                        }}
                        style={{ width: '100%' }}
                        options={parts.length == 0 ? [] : [
                            { label: 'All', value: 'All' },
                            ..._.uniqBy(parts, "value")
                        ]}
                    />
                </div>
                <div className='col-sm-2'>
                    <label className='small text-center'>Item Number</label>
                    <Select
                        showSearch
                        maxTagCount={"responsive"}
                        mode="multiple"
                        placeholder="Select Item"
                        value={inputData.ItemNumber}
                        onChange={(values) => {
                            if (values.includes('All')) {
                                if (inputData.ItemNumber && (inputData.ItemNumber.length === itemNumber.length)) {
                                    // Deselect all if "Select All" was deselected
                                    handleOnChange('ItemNumber', []);
                                } else {
                                    // Select all
                                    handleOnChange('ItemNumber', ["All"]);
                                }
                            } else {
                                // Update selected values normally
                                handleOnChange('ItemNumber', values);
                            }
                        }}
                        style={{ width: '100%' }}
                        options={itemNumber.length == 0 ? [] : [
                            { label: 'All', value: 'All' },
                            ..._.uniqBy(itemNumber, "value")
                        ]}
                    />
                </div>
                <div className='col-sm-2'>
                    <label className='small text-center'>Operation</label>
                    <Select
                        showSearch
                        maxTagCount={"responsive"}
                        mode="multiple"
                        placeholder="Select Operation"
                        value={inputData.Operation}
                        onChange={(values) => {
                            if (values.includes('All')) {
                                if (inputData.Operation && (inputData.Operation.length === operations.length)) {
                                    // Deselect all if "Select All" was deselected
                                    handleOnChange('Operation', []);
                                } else {
                                    // Select all
                                    handleOnChange('Operation', ["All"]);
                                }
                            } else {
                                // Update selected values normally
                                handleOnChange('Operation', values);
                            }
                        }}
                        style={{ width: '100%' }}
                        options={operations.length == 0 ? [] : [
                            { label: 'All', value: 'All' },
                            ..._.uniqBy(operations, "value")
                        ]}
                    />
                </div>

                <div className="col-sm-1">
                    <button className='btn btn-primary btn-sm mt-4' onClick={() => {
                        if (!inputData.InspectionType || (inputData.InspectionType.length == 0)) {
                            swal('Please select all inputs', { dangerMode: true });
                            return
                        }
                        else if (!inputData.ItemName || (inputData.ItemName.length == 0)) {
                            swal('Please select all inputs', { dangerMode: true });
                            return
                        }
                        else if (!inputData.ItemNumber || (inputData.ItemNumber.length == 0)) {
                            swal('Please select all inputs', { dangerMode: true });
                            return
                        }
                        else if (!inputData.Operation || (inputData.Operation.length == 0)) {
                            swal('Please select all inputs', { dangerMode: true });
                            return
                        }
                        handleGetData("Param")
                    }}>Apply</button>
                </div>
                <Modal
                    // title={<strong>Report    <button className="btn-sm btn-primary" onClick={demoFromHTML}>Download PDF</button></strong>}
                    centered
                    open={open}
                    // onOk={() => setOpen(false)}
                    onCancel={() => setOpen(false)}
                    footer={[]}
                    width={"95%"}
                >
                    <div id="customers" ref={customerRef} className='p-1  w-100'>
                        <Suspense fallback={<div>Loading...</div>}>
                            <DataEntryReportView
                                pdfData={pdfData}
                                ChecksheetType={reportData.InspectionType}
                                config={allTypeCache.find(x => x.InspectionType == reportData.InspectionType)}
                                obj={reportData}
                                QualityData={qualityData} item={getItem()} />
                        </Suspense>
                    </div>
                </Modal>
            </div>


            <Modal
                title=''
                centered
                open={pdfOpen}
                // onOk={() => setPdfOpen(false)}
                onCancel={() => setPdfOpen(false)}
                width={"95%"}
                footer={[]}
            >
                {/* <button className="btn-sm btn-primary" onClick={demoFromHTML}>Download PDF</button> */}
                <div id="customers" ref={customerRef} className='p-1  w-100'>
                    {reports[reportData.InspectionType]}
                    {/* <ProcessProductPatrolInspection item={allPartsCache.find(x => x.ItemName == inputData.ItemName)} company={company} data={reportData} pdfData={pdfData} /> */}
                </div>
            </Modal>



            {qualityData.length > 0 && <Table
                id="RejectionDetailedAnalysispiechart"
                onSort={() => { }}
                columns={columns1}
                sortColumn={sortColumn}
                // data={extractInspectionDataSeparateArray(qualityData[0])}

                data={qualityData}
            />}
            {console.log(qualityData, "gerjgnerkgberi")}
            {qualityData.length > 0 && <div className="float-end m-3">
                <PaginationComponent
                    current={CurrentPage}
                    pageSize={PageSize}
                    totalItems={TotalPage * PageSize}  // or just use total count
                    onPageChange={(page, size) => {
                        if (size !== PageSize) setCurrentPage(1);
                        else setCurrentPage(page);
                        setPageSize(size);
                    }}
                />
            </div>}

        </React.Fragment>
    );
}
export default QMSReport;